var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-dialog',{attrs:{"visible":_vm.chartFullscreen,"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","custom-class":"dialog-volumes-charts"},on:{"close":function($event){_vm.chartFullscreen = false}}},[_c('VolumesBarChart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }